import { useCallback, useEffect, useMemo } from 'react';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import emptyFunction from 'react-utils/emptyFunction';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import getLang from 'LearningCenterUI/utils/getLang';
import UsageTracker from '../../utils/UsageTracker';
import { cleanTrackingProps, toAwardType } from '../../utils/awardTrackingUtils';
import { useHistory, useRouteMatch, useLocation } from 'quartz-routing/react-router';
import { getAchievementSharePath } from '../../utils/RoutingUtils';
import { SingleAchievement, useAllAchievements } from '../../features/achievement';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AchievementPreviewModalByCredential = () => {
  const {
    isMobile
  } = useMediaQuery();
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch();
  const {
    grantedCredentialId: grantedCredentialIdParam
  } = match.params;
  const grantedCredentialId = Number(grantedCredentialIdParam);
  const {
    allAchievements
  } = useAllAchievements();
  const achievement = useMemo(() => {
    return (allAchievements || []).find(a => a.grantedCredentialId === grantedCredentialId);
  }, [allAchievements, grantedCredentialId]);
  useEffect(() => {
    var _achievement$credenti;
    if (!achievement) return;
    UsageTracker.trackStandalone('Award Interaction', cleanTrackingProps({
      action: 'view-achievement-preview-modal',
      type: toAwardType(achievement.credentialType),
      name: (_achievement$credenti = achievement.credentialDefinitionName) !== null && _achievement$credenti !== void 0 ? _achievement$credenti : '',
      itemId: grantedCredentialId.toString(),
      view: 'achievement-preview-modal'
    }));
  }, [grantedCredentialId, achievement]);
  const handleClose = useCallback(() => {
    var _achievement$credenti2;
    UsageTracker.trackStandalone('Award Interaction', cleanTrackingProps({
      action: 'close-achievement-preview-modal',
      type: toAwardType(achievement === null || achievement === void 0 ? void 0 : achievement.credentialType),
      name: (_achievement$credenti2 = achievement === null || achievement === void 0 ? void 0 : achievement.credentialDefinitionName) !== null && _achievement$credenti2 !== void 0 ? _achievement$credenti2 : '',
      itemId: grantedCredentialId.toString(),
      view: 'achievement-preview-modal'
    }));
    history.push(getAchievementSharePath(grantedCredentialId), location.state);
  }, [grantedCredentialId, history, location, achievement]);
  if (!achievement) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "achievement-preview-modal-by-credential",
    dialogStyles: {
      maxBlockSize: isMobile ? undefined : '90vh',
      overflowY: 'auto'
    },
    use: "conversational",
    width: 1250,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      color: "icon-core-subtle",
      "data-test-id": "achievement-close-preview",
      marginBlockStart: "50",
      onClick: handleClose
    }), /*#__PURE__*/_jsx(SingleAchievement, {
      inModal: true,
      language: getLang(),
      publicId: achievement.publicId,
      trackEvent: emptyFunction
    })]
  });
};
export default AchievementPreviewModalByCredential;